<nav class="navbar main">
  <h1>Мой личный блог</h1>
</nav>

<div class="container">
  <router-outlet></router-outlet>
</div>
